'use client';

import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/routing';
import { Logo } from '@/components/ui/logo';
import { RotateCw } from 'lucide-react';

/**
 * Ошибка внутри локали. Шапка и подвал приходят из layout.
 */
export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations('errors');

  useEffect(() => {
    // digest позволяет сопоставить показанную пользователю ошибку с серверным логом.
    console.error('Ошибка страницы:', error.digest ?? error.message);
  }, [error]);

  return (
    <div className="flex-1 flex flex-col items-center justify-center px-6 py-24 text-center">
      <Logo className="w-14 h-14 text-[var(--color-brand-500)]/30 mb-8" />

      <p className="text-7xl font-bold text-[var(--color-text-muted)]/40 mb-5 leading-none">500</p>
      <h1 className="text-2xl font-bold mb-3">{t('error_title')}</h1>
      <p className="text-[var(--color-text-muted)] mb-8 max-w-md leading-relaxed">
        {t('error_desc')}
      </p>

      <div className="flex flex-col sm:flex-row gap-3">
        <button
          onClick={reset}
          className="inline-flex items-center justify-center gap-2 px-7 py-3 rounded-xl bg-[var(--color-brand-500)] hover:bg-[var(--color-brand-400)] text-[var(--color-on-brand)] font-semibold transition-colors"
        >
          <RotateCw className="w-4 h-4" />
          {t('retry')}
        </button>
        <Link
          href="/"
          className="px-7 py-3 rounded-xl border border-[var(--color-border)] hover:border-[var(--color-accent-500)] bg-[var(--color-bg-card)] font-semibold transition-colors"
        >
          {t('home')}
        </Link>
      </div>

      {error.digest && (
        <p className="mt-10 text-xs text-[var(--color-text-muted)]/70">
          {/* Код нужен поддержке, чтобы найти ошибку в логах. */}
          ID: <code className="font-mono">{error.digest}</code>
        </p>
      )}
    </div>
  );
}
